import HTTP from '../common/http-common';

const END_POINT = '/addReduceDebit';

const list = (withdrawNo,jobNo,estimateNo,licenceNo,dateFrom,dateTo, branchCode) => HTTP.get(END_POINT+"?withdrawNo="+withdrawNo+"&jobNo="+jobNo+
                        "&estimateNo="+estimateNo+"&licenceNo="+licenceNo+
                        "&dateFrom="+dateFrom+"&dateTo="+dateTo + "&branchCode=" + branchCode);

const updateData = (addDebit,reduceDebit,grandWdTotal,oldGrandWdTotal,estimateInvoiceId,remark) => HTTP.post(END_POINT, {
    addDebit: addDebit,
    reduceDebit: reduceDebit,
    grandWdTotal: grandWdTotal,
    oldGrandWdTotal : oldGrandWdTotal,
    estimateInvoiceId: estimateInvoiceId,
    remark: remark
});

export {
    list,
    updateData
}